/* useNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./useNavigation.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { UI_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import Button from '@atlaskit/button';
import { Text } from '@atlaskit/primitives';
import ModalDialog, { ModalTransition, ModalFooter as AKModalFooter, ModalBody, ModalTitle, ModalHeader } from '@atlaskit/modal-dialog';
import { FORGE_UI_ANALYTICS_CHANNEL } from '../../../analytics';
import { BridgeClientError } from '..';
import { navigate } from './navigate';
import { getOrigin } from './getOrigin';
import { useEgressPermissionService } from '../../../utils/useEgressPermissionService';
import { makeUrl } from './makeUrl';
var cssActionItem = null;
export function useNavigation(_ref) {
  var extension = _ref.extension,
    push = _ref.push;
  var _useState = useState({
      state: 'closed'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var egressService = useEgressPermissionService('FETCH_CLIENT_SIDE', extension.egress);
  return {
    onNavigate: function () {
      var _onNavigate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var type, urlString, url, linkType, analyticsAttributes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = _ref2.type, urlString = _ref2.url;
              url = makeUrl(urlString);
              linkType = getLinkType(url, egressService);
              if (!(linkType === 'invalid' || !url)) {
                _context.next = 5;
                break;
              }
              throw new BridgeClientError("link is invalid: ".concat(urlString));
            case 5:
              if (!(linkType === 'trusted')) {
                _context.next = 8;
                break;
              }
              navigate(url.href, type, push);
              return _context.abrupt("return");
            case 8:
              analyticsAttributes = getAnalyticsAttributes(url);
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                  eventType: UI_EVENT_TYPE,
                  data: {
                    action: 'viewed',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                  }
                }).fire(FORGE_UI_ANALYTICS_CHANNEL);
                setModalState({
                  state: 'open',
                  url: url,
                  onConfirm: function onConfirm() {
                    navigate(url.href, type, push);
                    // TODO: remove this event once we have switched over to the new event schema
                    // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                    createAnalyticsEvent({
                      eventType: UI_EVENT_TYPE,
                      data: {
                        action: 'approved',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                      }
                    }).fire(FORGE_UI_ANALYTICS_CHANNEL);
                    resolve();
                  },
                  onCancel: function onCancel() {
                    // TODO: remove this event once we have switched over to the new event schema
                    // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                    createAnalyticsEvent({
                      eventType: UI_EVENT_TYPE,
                      data: {
                        action: 'cancelled',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                      }
                    }).fire(FORGE_UI_ANALYTICS_CHANNEL);
                    reject(new BridgeClientError('cancelled'));
                  }
                });
              }));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onNavigate(_x) {
        return _onNavigate.apply(this, arguments);
      }
      return onNavigate;
    }(),
    getModalJsx: function getModalJsx() {
      var _extension$properties;
      if (modalState.state === 'closed') {
        return /*#__PURE__*/React.createElement(ModalTransition, null);
      }
      var ModalFooter = function ModalFooter() {
        return /*#__PURE__*/React.createElement(AKModalFooter, null, /*#__PURE__*/React.createElement("div", {
          className: ax(["_1e0c1txw _1bah1yb4 _1bsb1osq"])
        }, /*#__PURE__*/React.createElement(Button, {
          href: "https://go.atlassian.com/forge-help-app-security",
          appearance: "subtle-link",
          target: "_blank",
          rel: "noopener noreferrer",
          className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"])
        }, "Learn more about app security"), /*#__PURE__*/React.createElement("div", {
          className: ax(["_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"])
        }, /*#__PURE__*/React.createElement("div", {
          className: ax(["_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"])
        }, /*#__PURE__*/React.createElement(Button, {
          appearance: "subtle",
          onClick: function onClick() {
            setModalState({
              state: 'closed'
            });
            modalState.onCancel();
          }
        }, "Cancel")), /*#__PURE__*/React.createElement("div", {
          className: ax(["_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"])
        }, /*#__PURE__*/React.createElement(Button, {
          appearance: "warning",
          onClick: function onClick() {
            modalState.onConfirm();
            setModalState({
              state: 'closed'
            });
          }
        }, "Continue")))));
      };
      return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(ModalDialog, {
        onClose: function onClose() {
          setModalState({
            state: 'closed'
          });
          modalState.onCancel();
        }
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, {
        appearance: "warning"
      }, "Opening external page on ".concat(modalState.url.hostname))), /*#__PURE__*/React.createElement(ModalBody, null, (_extension$properties = extension.properties) !== null && _extension$properties !== void 0 && _extension$properties.title ? /*#__PURE__*/React.createElement(Text, {
        as: "p"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "strong"
      }, extension.properties.title), " is sending you to an external page. Ensure you trust that page before you continue.") : /*#__PURE__*/React.createElement(Text, {
        as: "p"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "strong"
      }, "This app"), " is sending you to an external page. Ensure you trust that page before you continue."), /*#__PURE__*/React.createElement(Text, {
        as: "p",
        maxLines: 1
      }, modalState.url.href)), /*#__PURE__*/React.createElement(ModalFooter, null)));
    }
  };
}
var getRootDomain = function getRootDomain(url) {
  var hostnameParts = url.hostname.split('.');
  // Root domain consists of the last two parts of the hostname
  if (hostnameParts.length > 1) {
    return hostnameParts.slice(-2).join('.');
  } else {
    // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
  }
};

// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
var TRUSTED_ROOT_DOMAINS = ['atl-paas.net', 'atlassian.com', 'atlassian.net', 'ss-inf.net', 'jira.com', 'bitbucket.org', 'atlassian-us-gov-mod.com', 'atlassian-us-gov-mod.net'];

// Exported for testing only
export function getLinkType(url, egressService) {
  if (!url) {
    return 'invalid';
  }
  if (url.protocol === 'mailto:') {
    return 'trusted';
  }
  try {
    // URL is listed under permissions in manifest
    if (egressService.isValidUrl(url.href)) {
      return 'trusted';
    }

    // URL is from same origin
    if (url.origin === getOrigin()) {
      return 'trusted';
    }

    // URL is under a trusted atlassian domain
    var rootDomain = getRootDomain(url);
    if (TRUSTED_ROOT_DOMAINS.includes(rootDomain)) {
      return 'trusted';
    }
    if (['https:', 'http:'].includes(url.protocol)) {
      return 'external';
    }
  } catch (_unused) {}
  return 'invalid';
}

// Exported for testing only
export function getAnalyticsAttributes(url) {
  // Don't count the initial `?` in the query string length.
  var queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
  return {
    url: url.href,
    queryStringSize: queryStringSize
  };
}